import {filter, mergeMap, map, catchError} from 'rxjs/operators';
import {from, of, EMPTY} from 'rxjs';

import {combineEpics} from 'web-app/util/redux-observable';
import * as NewFileUploadActions from 'web-app/react/components/file-upload/new-actions';
import {getApolloClient} from 'web-app/api/clients/famly-app';
import LocalStorageService from 'web-app/services/local-storage';

import * as Actions from './actions';
import * as Queries from './queries';
import * as Helpers from './helpers';
import {type InstitutionsBehaviorsQuery} from './__generated__/queries.api-types';

const shouldFollowTaggingFlowObservable = () => {
    return from(
        getApolloClient().query<InstitutionsBehaviorsQuery>({
            query: Queries.InstitutionsBehaviors,
        }),
    ).pipe(
        mergeMap(({data}) => {
            return of(Helpers.shouldFollowTaggingFlow(data));
        }),
        catchError(() => {
            return of(false);
        }),
    );
};

const listenToFileUpload = action$ =>
    action$.ofType(NewFileUploadActions.addFile.type).pipe(
        filter(({payload}: ReturnType<typeof NewFileUploadActions.addFile.action>) => {
            return Helpers.isTaggableFile(payload.file);
        }),
        mergeMap(({payload}: ReturnType<typeof NewFileUploadActions.addFile.action>) => {
            const taggingAppModule = payload.config?.taggingAppModule;

            if (!taggingAppModule) {
                return EMPTY;
            }

            return shouldFollowTaggingFlowObservable().pipe(
                filter(shouldFollowTaggingFlow => {
                    return (
                        LocalStorageService.getFromLocalStorage('forceShouldFollowTaggingFlow') ||
                        shouldFollowTaggingFlow
                    );
                }),
                map(() => {
                    return Actions.show.action(payload.formName, taggingAppModule);
                }),
            );
        }),
    );

export default combineEpics(listenToFileUpload);
